/// <amd-module name="Test/TestResultHistory/Actions/HistoryViewActionHub" />
import * as React from "react";
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { Action } from "VSS/Reflux/Action";
import { Button } from "VSSUI/Button";

export interface IGroupedHistoryItem {
    key: string;
    historyForGroup: TCMContracts.TestResultHistoryForGroup;
    leftIndex: number;
    rightIndex: number;
    maxDateWithData: Date;
    minDateWithData: Date;
    nextButtonDisabled: boolean;
    prevButtonDisabled: boolean;
    nextButtonRef: React.RefObject<Button>;
    prevButtonRef: React.RefObject<Button>;
}

export interface IGroupedHistoryItemWithIndexAndNewResults {
    groupedHistoryItem: IGroupedHistoryItem;
    index?: number;
    newResults?: TCMContracts.TestHistoryQuery;
}

export class HistoryViewActionsHub {
    static readonly CHILD_SCOPE = "CHILD_SCOPE";
    static readonly SUBCHILD_SCOPE = "SUBCHILD_SCOPE";
    public setMaxHistoryItemsToShow = new Action<number>(HistoryViewActionsHub.CHILD_SCOPE);
    public historyLoaded = new Action<TCMContracts.TestHistoryQuery>(HistoryViewActionsHub.CHILD_SCOPE);
    public currentBuildOrReleaseHistoryLoaded = new Action<TCMContracts.TestHistoryQuery>(HistoryViewActionsHub.CHILD_SCOPE);
    public branchesLoaded = new Action<string[]>(HistoryViewActionsHub.CHILD_SCOPE);
    public previousButtonClicked = new Action<IGroupedHistoryItemWithIndexAndNewResults>(HistoryViewActionsHub.CHILD_SCOPE);
    public nextButtonClicked = new Action<IGroupedHistoryItemWithIndexAndNewResults>(HistoryViewActionsHub.CHILD_SCOPE);
    public disableNextAndPrevButtons = new Action<IGroupedHistoryItemWithIndexAndNewResults>(HistoryViewActionsHub.CHILD_SCOPE);
    public branchSelected = new Action<string>(HistoryViewActionsHub.CHILD_SCOPE);
    public clearBranchFilter = new Action<null>(HistoryViewActionsHub.CHILD_SCOPE);
    public onError = new Action<string>(HistoryViewActionsHub.CHILD_SCOPE);
    public regenerateHistory = new Action<null>(HistoryViewActionsHub.SUBCHILD_SCOPE);
}
